import styled from 'styled-components';

export const AccountTrendingInfoWrapper = styled.div`
 display: flex;
`;
